import { getProductionLines } from "@pazion/pazion-catalog/src/services/catalog-service";
import { Vue, Component } from "vue-property-decorator";
import {
  generateProductionsCut,
  changeLineStatus,
  generateCutByLine,
} from "@pazion/pazion-catalog/src/services/order-service";
import {
  IProductionRecord,
  IproductionCutInstance,
  ProductionStatusesEnum,
} from "@pazion/pazion-catalog/src/models/production.model";
import { SingleFilterType } from "@pazion/pazion-catalog/src/models/base";
import { formatDateTime } from "@pazion/pazion-core/src/services/base-service";
import {DataTableHeader} from "vuetify";

@Component({
  methods: {
    formatDateTime,
  },
})
export default class ProductionsListingMixin extends Vue {
  public loading: boolean = false;
  public search: string = "";
  public productionsList = [] as IproductionCutInstance[];
  public productionLinesData = [];

  public lineStatus: string | null = null;
  public deliverAtDefaultDate: string | null = null;
  private defaultRequestParams = { expand: "production" };
  public currentProdCut: string | null = null;
  public selectedGroup: string = "";

  public filterObject = {} as { [key: string]: any };

  public recordsLineStatuses = [
    { label: "New", value: ProductionStatusesEnum.NEW },
    { label: "Bewerken", value: ProductionStatusesEnum.BEWERKEN },
    { label: "Processed", value: ProductionStatusesEnum.PROCESSED },
  ];

  private filePlaiExtension: string = "data:text/plain;charset=utf-8,";
  private filePdfExtension: string = "data:application/pdf;base64,";
  public currentUpload = null;

  public footerProps = {
    itemsPerPageOptions: [50, 100, 200, -1],
  };

  // TODO: Deprecated
  public soloTableHeaders = [
    {
      text: "Production ",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "production.id",
      groupable: false,
    },
    // {
    //   text: "SKU",
    //   align: "left",
    //   class: "cell-truncate nowrap",
    //   sortable: false,
    //   cellClass: "nowrap",
    //   value: "sku",
    //   groupable: true
    // },
    {
      text: "Description",
      align: "left",
      class: "cell-truncate",
      sortable: false,
      value: "description",
      groupable: false,
      width: "25%",
    },
    {
      text: "Length",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "length",
      groupable: false,
    },
    {
      text: "Width",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "width",
      groupable: false,
    },
    {
      text: "Height",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "height",
      groupable: false,
    },
    {
      text: "Quantity",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "quantity",
      groupable: false,
    },{
      text: "Notes",
      align: "left",
      class: "cell-truncate",
      sortable: false,
      value: "notes",
      groupable: false,
      width: "25%",
    },
    {
      text: "Worktype",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "worktype",
      groupable: false,
    },
    {
      text: "Production at",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "production.productionAt",
      groupable: false,
    },
    {
      text: "Actions",
      class: "actions-row",
      align: "right",
      value: "actions",
      groupable: false,
      maxWidth: "300px",
    },
  ];

  public groupedTableItemHeaders: DataTableHeader[] = [
    {
      text: "sku",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "sku",
      groupable: false,
    },
    {
      text: "Sku",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "productsku",
      groupable: false,
    },
    {
      text: "name",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "name",
      groupable: false,
    },
    {
      text: "items",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "items",
      groupable: false,
    },
    {
      text: "sheets",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "sheets",
      groupable: false,
    },
    {
      text: "surface",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "surface",
      groupable: false,
    },
    {
      text: "actions",
      align: "right",
      class: "text-right mx-5",
      sortable: false,
      cellClass: "nowrap",
      value: "actions",
      groupable: false,
    },
  ];

  get getSoloTableHeaders(){
    return this.soloTableHeaders;//.filter( (header) => header.value );
  }

  async getDefaultProductionRecords(queryParams: { [key: string]: string }) {
    let finalQuery = queryParams;
    this.loading = true;
    this.productionsList = await getProductionLines(finalQuery);
    this.loading = false;
  }

  //NOTE: GET data by filters
  setFilters(filters: any) {
    this.filterObject = filters;
    this.fetchDataWithParams(filters);
  }

  fetchDataWithParams(filters?: SingleFilterType, reqParams?: any) {
    const fullFilters = filters || {};
    let fullFilter = {
      ...(reqParams || this.defaultRequestParams),
      filter: JSON.stringify(fullFilters),
    };
    this.getDefaultProductionRecords(fullFilter);
  }

  async onChangeLineStatus(item: any, status: string, fromDetails?: boolean) {
    if (status) {
      try {
        const response = await changeLineStatus(item.id, { status: status });
        if (response && response.hasOwnProperty("id")) {
          if (!fromDetails) {
            this.fetchDataWithParams(this.defaultRequestParams);
          } else {
            return response;
          }
        } else {
          this.$refs.toast.show({
            message: response.response?.data?.detail,
            icon: "mdi-close-circle",
            color: "red",
          });
          if (fromDetails) return false;
        }
      } catch (error) {
        this.$refs.toast.show({
          message: "Status hasn't been changed",
          icon: "mdi-close-circle",
          color: "red",
        });
      }
    }
  }

  createCsvFile(data: string, isPdf?: boolean) {
    const fullData = isPdf
      ? this.filePdfExtension + data
      : this.filePlaiExtension + data;
    this.currentProdCut = encodeURI(fullData);
    this.$nextTick(() => {
      (this.$refs.referralLink as HTMLLinkElement) &&
        this.$refs.referralLink.click();
      this.currentUpload = null;
    });
    this.$refs.toast.show({
      message: "File has been downloaded",
      color: "green",
    });
    this.productionLinesData = [];
    this.fetchDataWithParams();
  }

  async generateFileByLineId(item: IProductionRecord | IproductionCutInstance) {
    this.loading = true;
    try {
      const response = await generateCutByLine(item?.id);
      if (!response || (response && !response.hasOwnProperty("content"))) {
        this.$refs.toast.show({
          message:
            response?.response?.data?.message || "file hasn't been downloaded",
          color: "red",
          icon: "mdi-close-circle",
        });
        this.loading = false;
        return;
      }
      this.currentUpload = response;
      item.printedAt = 'yes';
      this.createCsvFile(response.content, true);
    } catch (error) {
      this.$refs.toast.show({
        message: error?.response?.data.detail || "file hasn't been downloaded",
        color: "red",
        icon: "mdi-close-circle",
      });
      this.loading = false;
    }
  }

  async generateProductionCut() {
    const cutData = {
      productionLines: this.productionLinesData.map(
        (line: IproductionCutInstance) => ({ id: line.id })
      ),
    };

    const response = await generateProductionsCut(cutData);
    if (!response || !response.success) {
      this.$refs.toast.show({
        message: response.response.data.message,
        color: "red",
        icon: "mdi-close-circle",
      });
      return;
    }
    this.createCsvFile(response.data);
  }

  onSelectGroup(group: string, items: any, status?: boolean) {
    if (!status) {
      this.selectedGroup = group;
      this.productionLinesData = items;
    } else {
      this.selectedGroup = "";
      this.productionLinesData = [];
    }
  }

  onUpdateOptions(opt: { sortBy: string[]; sortDesc: boolean[] }) {
    let sortField = opt.sortBy.length && opt.sortBy[0];
    const isDesc = opt.sortBy.length && opt.sortDesc[0];
    if (sortField == "productionAt") {
      sortField = "production.productionAt";
    }
    const currentRule = isDesc ? "DESC" : "ASC";
    if (sortField && currentRule) {
      this.sortOrder = { [sortField]: currentRule };
      this.fetchDataWithParams();
    }
  }

  fetchData() {
    this.lineStatus = this.recordsLineStatuses[0].value;
    this.fetchDataWithParams();
  }

  get getHeaders() {
    return this.soloTableHeaders;
  }

  get getProductionRecords() {
    return this.productionsList;
  }

  get lineStatuses() {
    return this.recordsLineStatuses;
  }

  get canCreateCut() {
    return this.productionLinesData?.length > 0;
  }
} //
